import { render, staticRenderFns } from "./QuestionsAnswers.vue?vue&type=template&id=5f6c675d"
import script from "./QuestionsAnswers.vue?vue&type=script&lang=js"
export * from "./QuestionsAnswers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports